// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyArJx6aGk1KCNvy87BGA0c3mnYctmmbXfE",
    authDomain: "lovingarms.firebaseapp.com",
    projectId: "lovingarms",
    storageBucket: "lovingarms.firebasestorage.app",
    messagingSenderId: "525525597631",
    appId: "1:525525597631:web:a21649100ee630c5c1750a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
export default app;